import { TestCreditCardGenerator } from '@paypalcorp/developeruikit'
import '@paypalcorp/developeruikit/lib/cjs/index.css'
import React from 'react'
import Layout from '../layout'

import { useApplicationContext } from '../../provider'

export default function Home(props) {
  const { user } = useApplicationContext()
  const userLoggedIn = user && user.loggedIn

  return (
    <Layout
      leftNavBar={true}
      layout="dx-docs"
      activeNavLocal
      location={props.location}
    >
      <div id="hashLinkContainer" />
      <main
        className="content dx-content"
        id={userLoggedIn ? 'Authed' : 'Unauthed'}
      >
        <div className="" style={{}}>
          <h1 className="homepageTitle" data-testid="header-title">
            PayPal Sandbox Test Card Generator (For Developers Only)
          </h1>
          <p>
            This tool generates fake credit card numbers for testing purposes in
            the PayPal Sandbox environment. These card numbers are not real and
            cannot be used for actual payments.
          </p>
          <p>
            It is intended only for developers building and testing PayPal
            integrations. If you are looking for real payment options, visit{' '}
            <a
              href="https://www.paypal.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              PayPal
            </a>
            .
          </p>
          <blockquote>
            <strong>Important:</strong> The card numbers generated here are
            simulated and will only work in PayPal&apos;s{' '}
            <a
              href="https://www.sandbox.paypal.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Sandbox (test) environment
            </a>
            . They are not valid for real transactions.
          </blockquote>
          <TestCreditCardGenerator handleSelectedCard={(card) => {}} />
        </div>
        <br />
      </main>
    </Layout>
  )
}
